import { MutationTree } from 'vuex';
import { ITrackingState } from '@signing-page/tracking/store/tracking.store';
import { IDocumentPage } from '@/types/document-page';

export const mutationSetCurrentDocumentPages = 'setCurrentDocumentPages';
export const mutationSetPageViewStopWatchPaused = 'setPageViewStopWatchPaused';
export const mutationSetSuspendPageTracking = 'setSuspendPageTracking';
export const mutationSetTrackingDisabled = 'setTrackingDisabled';

export const mutations: MutationTree<ITrackingState> = {
  [mutationSetCurrentDocumentPages](state, pages: IDocumentPage[]) {
    state.currentDocumentPages = pages;
  },
  [mutationSetPageViewStopWatchPaused](state, paused: boolean) {
    state.pageViewStopWatchPaused = paused;
  },
  [mutationSetSuspendPageTracking](state, suspend: boolean) {
    state.suspendPageTracking = suspend;
  },
  [mutationSetTrackingDisabled](state, disabled: boolean) {
    state.trackingDisabled = disabled;
  },
};
